import { useState } from "react"
import { useQuery } from "react-query"
import { createPaymentIntent, getAll } from "./services/api"
import { Box, Button, CircularProgress, Container, Divider, Grid, Paper, Typography } from "@mui/material"
import { PaymentForm } from "./modules/PaymentForm"
import { useEffect } from "react"
import { Elements } from "@stripe/react-stripe-js"
import { loadStripe } from "@stripe/stripe-js"

const stripePromise = loadStripe('pk_test_51NYDIdBfR5m0xlwA0dRX3fHUBHSAyRtHuEVj87jf1kGQczIuLOAKBXF6kxltvt552SURhnkabwYFkIAVXNc73R1b00fUaipUaa');

export default function PaymentPlan() {
  const [state, setState] = useState({
    plan: null,
    stripeClientSecret: null
  })
  const { data } = useQuery('paymentsPlansList', getAll, { refetchOnWindowFocus: false })
  const { data: PaymentIntent } = useQuery(
    ['paymentIntent', state.plan !== null ? state.plan.price : null],
    () => createPaymentIntent(state.plan !== null ? state.plan.price : null),
    { refetchOnWindowFocus: false, enabled: state.plan !== null }
  )

  const [options, setOptions] = useState({
    clientSecret: null
  })

  useEffect(() => {
    if (PaymentIntent !== undefined && PaymentIntent !== null) {
      setState({ ...state, stripeClientSecret: PaymentIntent.data.client_secret })
      setOptions({ ...options, clientSecret: PaymentIntent.data.client_secret })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [PaymentIntent])

  const handleSelectPlan = (plan) => {
    setState({ plan: plan, stripeClientSecret: null })
    setOptions({ ...options, clientSecret: null })
  }

  return (
    <>
      <Box component="main">
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
          <Typography variant="h6" component="p">Selecciona un paquete</Typography><Divider sx={{ marginTop: 2, marginBottom: 2 }} />
          {state.stripeClientSecret !== null ?
            <Elements stripe={stripePromise} options={options}>
              <PaymentForm stripe_client_secret={state.stripeClientSecret} />
            </Elements>
            : null
          }
          {data !== undefined ?
            <Grid container spacing={2}>
              {data.data.map((plan, index) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                  <Paper sx={{ p: 2 }}>
                    <div style={{ textAlign: "center" }}>
                      <Typography variant="h5" component="p" sx={{ mb: 2 }}>{plan.name}</Typography>
                      <Typography variant="h4" component="p" >${plan.price}</Typography>
                      <Typography variant="subtitle2" component="p" sx={{ mb: 2 }}>por mes</Typography>
                      <Button
                        onClick={() => handleSelectPlan(plan)}
                        size="large" variant="contained" sx={{ mb: 7 }}>
                        Probar gratis
                      </Button>
                      <Typography variant="body1" component="p" sx={{ mb: 2 }}>14 days trial. No credit card needed. Cancel anytime.</Typography>
                    </div>
                    <Divider sx={{ marginTop: 3, marginBottom: 3, color: "red" }} />
                    <Typography variant="body1" component="div" sx={{ mb: 2 }}>
                      <ul>
                        <li>Feature 1</li>
                        <li>Feature 2</li>
                        <li>Feature 3</li>
                        <li>Feature 4</li>
                        <li>Feature 5</li>
                        <li>Feature 6</li>
                        <li>Feature 7</li>
                        <li>Feature 8</li>
                        <li>Feature 9</li>
                        <li>Feature 10</li>
                        <li>Feature 11</li>
                        <li>Feature 12</li>
                      </ul>
                    </Typography>
                  </Paper>
                </Grid>
              ))}
            </Grid>
            : <CircularProgress />}
        </Container>
      </Box>
    </>
  )
}